import { SUPPORT_URL } from '../Support/SupportTab'

type ContactSupportLinkProps = {
  message?: string
  className?: string
}

export const ContactSupportLink = ({
  message = 'Problemas para entrar? Fale com o suporte.',
  className = 'link-primary fs-7 d-inline-block px-2 py-2',
}: ContactSupportLinkProps) => (
  <a href={SUPPORT_URL} target='_blank' rel='noopener noreferrer' className={className}>
    {message}
  </a>
)
